var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectionPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60154 1V0.9H1.50154H0.40918H0.30918V1V22.1674V22.2674H0.40918H1.50154H1.60154V22.1674V1Z",
    fill: "#FF66B1",
    stroke: "#FF66B1",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92673 1V0.9H3.82673H2.73438H2.63437V1V22.1674V22.2674H2.73438H3.82673H3.92673V22.1674V1Z",
    fill: "#FF66B1",
    stroke: "#FF66B1",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48368 1.39688L5.44772 1.30357L5.35441 1.33953L4.33513 1.73234L4.24182 1.7683L4.27778 1.86161L11.8896 21.6129L11.9256 21.7063L12.0189 21.6703L13.0381 21.2775L13.1315 21.2415L13.0955 21.1482L5.48368 1.39688Z",
    fill: "#FF66B1",
    stroke: "#FF66B1",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionPink);
export default __webpack_public_path__ + "static/media/collection_Pink.95876ce2e8f7bf4998738aacf484885c.svg";
export { ForwardRef as ReactComponent };